import React from "react";
import "./WeightHero.css";
import { ProductCard } from "../../components";

const WeightHero = () => {
  return (
    <div className="whero_main_wrapp">
      <div className="whero_card_wrapp">
        <ProductCard />
      </div>
    </div>
  );
};

export default WeightHero;
